import type { ComputedRef, InjectionKey } from 'vue'
import type { ServiceAreaSet } from './types'

export interface ServiceAreaContext {
  sets: ComputedRef<Map<string, ServiceAreaSet>>
}

export const serviceAreaContextKey: InjectionKey<ServiceAreaContext> = Symbol('service-area-context')
